import script from "./CreateRootInstance.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateRootInstance.vue?vue&type=script&setup=true&lang=js"

import "./CreateRootInstance.vue?vue&type=style&index=0&id=5001c972&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5001c972"]])

export default __exports__